import React from 'react';
import { Col, Form, Row, Typography, Radio, Space } from 'antd';

const InfoSection = ({ questionCompanies, title, name }) => {
  if (questionCompanies.length === 0) return null;
  return (
    <Row gutter={24}>
      <Col span={9}>
        <Typography.Title level={3}>{title}</Typography.Title>
      </Col>
      <Col span={15}>
        <Form.Item name={name}>
          <Radio.Group>
            <Space direction='vertical'>
              {questionCompanies.map((company) => (
                <Radio value={company.id} key={company.id}>
                  {company.name}
                </Radio>
              ))}
            </Space>
          </Radio.Group>
        </Form.Item>
      </Col>
    </Row>
  );
};

export default React.memo(InfoSection);
